import axios from 'axios';
import {call, put, takeEvery, takeLatest} from 'redux-saga/effects';
import constants from 'constants';
import actions from 'actions';
import {toast} from 'react-toastify';
import {push} from 'redux-router';

const {
  addErrorsSaga
} = actions;

const {
  UNSUBSCRIBE_SAGA,
  API_UNSUBSCRIBE
} = constants;

const apiUnsubscribe = (token) => (
  axios.put(`${API_UNSUBSCRIBE}/${token}`)
);

function* unsubscribe({token}) {
  try {
    const response = yield call(apiUnsubscribe, token);
    yield call(toast.success, response.data.message);
    // yield put(push('/'));
  } catch (e) {
    yield put(addErrorsSaga(UNSUBSCRIBE_SAGA, e.response))
  }
}

function* __unsubscribeSaga() {
  yield takeEvery(UNSUBSCRIBE_SAGA, unsubscribe)
}

export {
  __unsubscribeSaga
};



// WEBPACK FOOTER //
// ./src/sagas/unsubscribe.js